import moment from 'moment';

import * as Actions from './hold-until.actions';

const initialState = {
  isLoading: false,
};

const actionHandlerMap = {
  [Actions.LAUNCH_HOLD_UNTIL_MODAL]: (state, action) => {
    const { fulfillmentPlanIds } = action;
    return {
      ...state,
      holdUntilDate: moment().startOf('day').add(1, 'd').toISOString(),
      fulfillmentPlanIds,
    };
  },
  [Actions.LAUNCH_REMOVE_HOLD_MODAL]: (state, action) => {
    const { fulfillmentPlanIds, showNumberOfOrders } = action;
    return {
      ...state,
      holdUntilDate: null,
      fulfillmentPlanIds,
      showNumberOfOrders,
    };
  },
  [Actions.HOLD_UNTIL]: (state) => {
    return {
      ...state,
      isLoading: true,
    };
  },
  [Actions.HOLD_UNTIL_MODAL_CLOSED]: () => {
    return initialState;
  },
  [Actions.SET_IS_LOADING]: (state, action) => {
    const { isLoading } = action;
    return {
      ...state,
      isLoading,
    };
  },
};

export const reduce = (state = initialState, action) => {
  const actionHandler = actionHandlerMap[action.type];
  if (!actionHandler) {
    return state;
  }
  return actionHandler(state, action);
};

export { namespace } from './hold-until.reducer.metadata';
